module.exports = __webpack_public_path__ + "static/tiq_app_icon-90a98f31e809ba79b2386f9c40aad70c.png";